module.exports = __webpack_public_path__ + "static/media/custom-domain.ba2702c1.svg";